<script lang="ts">
  import Loader from '$shared/atoms/Loader/Loader.svelte';

  interface Props {
    list?: CommonList[];
    loading?: boolean;
    onclick?: (item: CommonList) => void;
  }

  let { list = [], loading = false, onclick }: Props = $props();
</script>

<div class="comp-breadcrumb" data-cy="breadcrumb">
  {#if loading}
    <div class="loader">
      <div class="loader-i"><Loader /></div>
      <div class="loader-i"><Loader /></div>
    </div>
  {:else}
    {#each list as item}
      {#if item.label}
        <button class="breadcrumb-i" onclick={() => onclick?.(item)}>{item.label}</button>
      {/if}
    {/each}
  {/if}
</div>

<style>
  .loader {
    display: flex;
    align-items: center;
    height: 26px;
  }

  .loader .loader-i {
    width: 100px;
    height: 26px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--grey-light);
  }

  .breadcrumb-i {
    font-weight: 600;
    font-size: 22px;
    line-height: 26px;
    color: var(--grey-light);
    position: relative;
  }
  .loader .loader-i:not(:last-child),
  .breadcrumb-i:not(:last-child) {
    padding-right: 16px;
  }
  .loader .loader-i:not(:last-child)::after,
  .breadcrumb-i:not(:last-child)::after {
    content: '/';
    color: var(--grey-light);
    width: 16px;
    text-align: center;
    position: absolute;
    top: 0;
    right: 0;
  }

  .breadcrumb-i:last-child {
    font-weight: 700;
    font-size: 22px;
    line-height: 26px;
    color: var(--black);
  }
  .breadcrumb-i:hover {
    color: var(--blue);
  }
</style>
